import { DROPDOWN_ACCOUNTS as PREFIX } from "const";
import { ACCOUNT_GET_DROPDOWN_LIST_METHOD, ACCOUNT_MERGE_METHOD } from "const/apiMethods";
import { api } from "api/loginRoutes";
import { createAction } from  "./defaults";

const setAccounts = createAction("SET_ITEMS_" + PREFIX);
const setLoading = createAction("SET_LOADING_" + PREFIX);

export const getDropdownAccounts = (filters = null) => (dispatch) => {
    dispatch(setLoading(true));

    api(ACCOUNT_GET_DROPDOWN_LIST_METHOD, {
        filter: filters || {}
    }).then(({account_list = []}) => {
        dispatch( setAccounts({
            items: account_list,
            filter: filters
        }) );
    }).finally(() => {
        dispatch(setLoading(false))
    });
};

export const mergeAccounts = (firstAccountId, secondAccountId) => async (dispatch) => {
    return await api(ACCOUNT_MERGE_METHOD, {
        target: {
            account_id: firstAccountId,
            account1_id: secondAccountId
        }
    });
}